import { isMobile } from '@util/index';
import BaseModal from '../../../components/modals/BaseModal';
import HelpRequestForm from 'features/helpWithOrder/forms/HelpRequestForm';

interface HelpRequestModalProps {
  isOpen: boolean;
  dismiss: () => void;
  order_id: string;
  variant?: 'buyer' | 'seller';
}

export default function HelpRequestModal({
  isOpen,
  dismiss,
  order_id,
  variant = 'buyer',
}: HelpRequestModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      dismiss={dismiss}
      title={`Help with your order`}
      overflowType="visible"
      isFullScreen={isMobile()}
    >
      <HelpRequestForm
        order_id={order_id}
        variant={variant}
        dismiss={dismiss}
      />
    </BaseModal>
  );
}
